import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/core/components/base.component';
import { GetTownModel } from 'src/app/core/services/api-services';
import { CityService } from 'src/app/core/services/api-services';
import CustomValidators from 'src/app/core/validators/custom-validators.validator';
import { customValidator } from 'src/app/core/validators/custom.validator';
const postalCodeLength: number = 4;
const blockedPostalCodes: string[] = ['9485', '9486', '9487', '9488', '9489', '9490', '9491', '9492', '9493', '9494', '9495', '9496', '9497', '9498', '9499'];

@Component({
    selector: 'postal-code',
    templateUrl: './postal-code.component.html',
    styleUrls: ['./postal-code.component.scss'],
    standalone: false
})
export class PostalCodeComponent extends BaseComponent implements OnInit {
  @Input() postalCodeControl!: FormControl;
  @Input() label!: string;
  @Input() maxLength: number | null = null;
  @Input() checkBlocked: boolean = false;
  @Output() result = new EventEmitter<string>();

  formGroup = this.formBuilder.group({
    item: this.formBuilder.control(null, [customValidator(() => this.postalCodeControl.invalid, () => this.postalCodeControl.errors)])
  });

  constructor(private readonly formBuilder: FormBuilder,
    private readonly cityService: CityService) {
    super();
  }

  ngOnInit() {
    const hasRequiredValidator = this.postalCodeControl.validator 
      ? this.postalCodeControl.validator(this.postalCodeControl)?.hasOwnProperty('required') 
      : false;

    if (hasRequiredValidator && !this.label.includes('*')) {
      this.label += "*";
    }

    this.postalCodeControl.statusChanges
      .unsubscribeOnDestroy(this)
      .subscribe(() => {
        this.itemControl.updateValueAndValidity();
      });

    this.postalCodeControl.valueChanges
      .unsubscribeOnDestroy(this)
      .subscribe((value: string) => {
        this.itemControl.setValue(value);
      });

    // Set initial value
    this.itemControl.setValue(this.postalCodeControl.value);
  }
  
  isNumber(value) {
    const numberRegex = /^-?\d+(\.\d+)?$/;
    return numberRegex.test(value);
  }
  
  postalCodeChanged() {
    this.postalCodeControl.setValue(this.itemControl.value);
    if (this.checkBlocked) {
      if (blockedPostalCodes.indexOf(this.itemControl.value) !== -1) {
        this.postalCodeControl.setErrors({ 'blocked': true });
      }
      else if (!this.itemControl.hasError('pattern')) {
        this.itemControl.markAsPristine();
      }
    }

    if (this.itemControl.value && this.isNumber(this.itemControl.value) && this.itemControl.value?.length == postalCodeLength) {
      let model: GetTownModel = {
        street: null,
        number: null,
        zip: this.itemControl.value,
        location: null
      }

      this.cityService.cityByPostalCode(model)
        .subscribe(value => {
          if (value && value.queryAutoComplete4Result) {
            if (value.queryAutoComplete4Result.autoCompleteResult.length > 0) {
              var city = value.queryAutoComplete4Result.autoCompleteResult[0].townName;
              this.result.emit(city);
            }
            else {
              this.result.emit(undefined);
            }
          }
        });
    }
  }

  ngDoCheck() {
    if (this.postalCodeControl.touched && !this.itemControl.touched) {
      this.itemControl.markAsTouched();
    }

    if (this.postalCodeControl.disabled && !this.itemControl.disabled) {
      this.itemControl.disable();
    }

    if (this.postalCodeControl.enabled && !this.itemControl.enabled) {
      this.itemControl.enable();
    }
  }

  get itemControl(): FormControl {
    return this.formGroup.controls.item as FormControl;
  }
}
